<div class="ask">
  <ng-container *ngIf="viewMode">
    <div class="container">
      <div class="ask__header" *ngIf="title && askList.length">Someone Asked</div>
      <section class="products" [ngClass]="grid ? 'grid-' + gridNumber : 'list'">
        <ng-container *ngFor="let i of askList">
          <div class="ask__my-card" (click)="viewAsk(ViewAsk, i.message, i)">
            <div class="message">"{{ i.message | slice : 0 : 50 }}"</div>
            <div class="user">
              <img loading="lazy" src="{{ i.profileImage }}" alt="" />
              {{ i.appUser?.profileCharacterName }}
            </div>
          </div>
        </ng-container>
      </section>
    </div>
  </ng-container>

  <ng-container *ngIf="!viewMode">
    <div class="ask__no-product">
      <div (click)="openAddPopup()">
        <i class="fa fa-plus" aria-hidden="true"></i>
        <span class="pl-2">Add</span>
      </div>
    </div>

    <ng-container *ngFor="let i of askList">
      <div class="ask__profile">
        <div class="message">
          {{ i.message }}
        </div>
        <div class="detail">
          <div class="cate">
            {{ i.category }} /
            {{ i.subCategory }}
          </div>
          <i class="fa fa-trash absolute" (click)="deleteAsk(i.id)" aria-hidden="true"></i>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #askPopup let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div class="my-modal__body">
    <div class="nav-select mt-4">
      <app-multi-dropdown [placeholder]="selectedCategoryNameForDD && selectedCategoryNameForDD != 'null' ? selectedCategoryNameForDD : 'Category'" [items]="categoriesList" (itemSelected)="onCategoryChange($event?.categorieChildId, $event?.categoryName)"></app-multi-dropdown>
      <app-multi-dropdown [placeholder]="selectedSubCategoryName && selectedSubCategoryName != 'null' ? (regionSplit(selectedSubCategoryName) | titlecase) : 'Sub-Category'" [items]="addedSubCategoryList" (itemSelected)="onRegionClick($event.name)"></app-multi-dropdown>
    </div>

    <h2 class="title">Ask</h2>
    <div class="form-group">
      <textarea class="form-control" placeholder="Enter Your Question" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="askMsg" rows="6"></textarea>
    </div>
    <button class="d-flex ml-auto my-button-3" (click)="submitAsk()">Save <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
  </div>
</ng-template>

<ng-template #ViewAsk let-modal>
  <div id="ask_detail_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="ask-modal">
      <div class="ask-modal__close" (click)="modal.dismiss('Cross click')">
        <i class="fa-solid fa-times"></i>
      </div>
      <div class="ask-modal__title">
        <i class="fa-solid fa-question-circle"></i>
      </div>
      <div class="ask-modal__question">
        <img loading="lazy" src="{{ ask.profileImage }}" style="width: 120px" alt="" />
        <div class="body">
          <div class="body__header">
            <div class="name">{{ ask.appUser?.profileCharacterName }}</div>
          </div>
          <div class="body__msg">"{{ askMsg }}"</div>
          <div class="meta">
            <div class="date"><i class="fa-regular fa-clock"></i> {{ ask.createdAt }}</div>
            <div class="like">
              <i (click)="likeForum(ask.id, ask)" class="i fa-{{ hasCheckedForum(ask.memberShopAskLikes) ? 'solid' : 'regular' }} fa-heart"></i>
              {{ ask.memberShopAskLikes.length }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="card border-0 mt-2 bg-light">
        <div class="card-body">
          <div class="d-flex" style="gap: 1em">
            <div>
              <img loading="lazy" src="{{ ask.profileImage }}" style="width: 120px" alt="" />
            </div>
            <div class="d-flex flex-column w-100">
              <h3 class="d-md-block d-none">
                {{ ask.appUser?.profileCharacterName }}
              </h3>
              <h5 class="d-md-none d-block">
                {{ ask.appUser?.profileCharacterName }}
              </h5>
              <div class="card w-100 rounded" style="background-color: #692cbd">
                <div class="card-body">
                  <h1 class="text-white d-md-block d-none">"{{ askMsg }}"</h1>
                  <h3 class="text-white d-md-none d-block">"{{ askMsg }}"</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-between border-0">
          <h6><i class="fa-regular fa-clock"></i> {{ ask.createdAt }}</h6>
          <div class="d-flex">
            <div class="text-salmon ml-auto" style="color: salmon">
              {{ ask.memberShopAskLikes.length }}
              <span
                style="cursor: pointer"
                (click)="likeForum(ask.id, ask)"
                class="i fa-{{
                  hasCheckedForum(ask.memberShopAskLikes) ? 'solid' : 'regular'
                }} fa-heart"
              ></span>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <app-ask-forum [ask]="ask"></app-ask-forum> -->
    </div>
  </div>
</ng-template>
